import React, { useState } from 'react';
import { userService } from '../services/api';

const ConnectModal = ({ user, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    connect_opted_in: user.connect_opted_in || false,
    connect_method: user.connect_method || '',
    connect_value: user.connect_value || '',
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === 'connect_opted_in' && !checked) {
      // Clear connection fields when opting out
      setFormData(prevState => ({
        connect_opted_in: false,
        connect_method: '',
        connect_value: ''
      }));
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await userService.updateUser(user.id, formData);
      onUpdate(response.data);
      onClose(); // This should close the modal after a successful update
    } catch (error) {
      console.error('Failed to update Connect settings:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-11/12 max-w-md text-center">
        <h2 className="text-xl font-bold mb-4">Join matching</h2>
        <p className="text-gray-600 mb-4 text-sm">
          Opting into matching allows your AI thought partner(s) to "connect" you to other like-minded users, once they've gotten to know you!
        </p>
        <div className="bg-blue-50 border border-blue-200 text-blue-800 px-4 py-3 rounded-md mb-5 text-sm">
          <p className="font-bold mb-1">How to find your matches:</p>
          <ol className="text-left list-decimal pl-5">
            <li> Click on the "My Matches" button to your right!</li>
            <li> Text "<strong>@match</strong>" to one of your thought partners.</li>
          </ol>
        </div>
        
        <form onSubmit={handleSubmit} className="flex flex-col">
          <div className="text-center mb-5">
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="connect_opted_in"
                checked={formData.connect_opted_in}
                onChange={handleChange}
                className="w-4 h-4 mr-2"
              />
              <span>Opt-in</span>
            </label>
          </div>
          
          {formData.connect_opted_in && (
            <>
              <select
                name="connect_method"
                value={formData.connect_method}
                onChange={handleChange}
                required
                className="w-full p-3 border border-gray-300 rounded mb-4 bg-white appearance-none"
                style={{
                  backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23333333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 10px center",
                  paddingRight: "30px"
                }}
              >
                <option value="">Select connection method</option>
                <option value="instagram">Instagram</option>
                <option value="twitter">Twitter</option>
                <option value="reddit">Reddit</option>
                <option value="phone">Phone Number</option>
                <option value="email">Email</option>
              </select>
              
              <input
                type="text"
                name="connect_value"
                value={formData.connect_value}
                onChange={handleChange}
                placeholder={`Enter your ${formData.connect_method}`}
                required
                className="w-full p-3 border border-gray-300 rounded mb-6"
              />
            </>
          )}
          
          <div className="flex justify-center gap-4">
            <button 
              type="button" 
              onClick={onClose}
              className="px-6 py-2 bg-white border border-black rounded hover:text-tropical-indigo hover:border-tropical-indigo font-bold"
            >
              Cancel
            </button>
            <button 
              type="submit"
              className="px-6 py-2 bg-tropical-indigo text-white border-none rounded hover:opacity-90 font-bold"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ConnectModal;
